import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { integerInput, whiteSpaceCheck } from "../../helper/helper";
const ResidenceInfo = ({ register, errors }) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Current Residence Information</span>
      <Row className="mb-3 gx-sm-3 gx-2">
      <Col xl={3} md={4} sm={6} className="mb-3">         
       <Form.Group controlId="formSurname">
            <Form.Label>Address Line 1 <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter line 1"
              name="CurrentAddressLineOne"
              {...register("CurrentAddressLineOne", {
                required: ValidationMessage.ADDRESS_LINE_One,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="CurrentAddressLineOne"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>Address Line 2 </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter line 2"
              name="CurrentAddressLineTwo"
              {...register("CurrentAddressLineTwo", {
                required: false,
              })}
            />

            <ErrorMessage
              errors={errors}
              name="CurrentAddressLineTwo"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>District</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter district"
              name="currentDistrict"
              {...register("currentDistrict", {
                required: ValidationMessage.DISTRICT_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />

            <ErrorMessage
              errors={errors}
              name="currentDistrict"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formYearOfBirth">
            <Form.Label>City <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter city"
              name="currentCity"
              {...register("currentCity", {
                required: ValidationMessage.CITY_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />

            <ErrorMessage
              errors={errors}
              name="currentCity"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formYearOfBirth">
            <Form.Label>State <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter state"
              name="currentState"
              {...register("currentState", {
                required: ValidationMessage.STATE_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />

            <ErrorMessage
              errors={errors}
              name="currentState"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>Country <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter country"
              name="currentCountry"
              {...register("currentCountry", {
                required: ValidationMessage.COUNTRY_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />

            <ErrorMessage
              errors={errors}
              name="currentCountry"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>Landmark <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter landmark"
              name="currentLandMark"
              {...register("currentLandMark", {
                required: ValidationMessage.LANDMARK_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />

            <ErrorMessage
              errors={errors}
              name="currentLandMark"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>Pin-code <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter pin-code"
              name="currentPinCode"
              {...register("currentPinCode", {
                required: ValidationMessage.PIN_CODE_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
              onKeyPress={(e) => integerInput(e)}
              maxLength={6}
            />

            <ErrorMessage
              errors={errors}
              name="currentPinCode"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default ResidenceInfo;
